<template>
  <div style="z-index: 1">
    <svg
      class="pipeline_vertical"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="100%"
      height="100%"
      viewBox="0 0 24 120"
      preserveAspectRatio="none"
    >
      <title>{{ hint }}</title>
      <defs>
        <linearGradient
          id="pv-KeyGradient"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="0"
          x2="24"
          y2="0"
        >
          <stop style="stop-opacity: 1; stop-color: #99a1af" offset="0" />
          <stop style="stop-opacity: 1; stop-color: #e3e2e2" offset="0.50" />
          <stop style="stop-opacity: 1; stop-color: #99a1af" offset="1" />
        </linearGradient>
        <linearGradient
          id="pv-OilGradient"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="0"
          x2="24"
          y2="0"
        >
          <!--https://tailwindcss.com/docs/colors gray-->
          <stop style="stop-opacity: 1; stop-color: #868485" offset="0" />
          <stop style="stop-opacity: 1; stop-color: #99a1af" offset="0.5" />
          <stop style="stop-opacity: 1; stop-color: #868485" offset="1" />
        </linearGradient>
        <rect id="pv-main" x="0" y="0" width="24" height="100%" />
      </defs>
      <g :visibility="fState[0]">
        <use href="#pv-main" fill="url(#pv-KeyGradient)" />
      </g>
      <g :visibility="fState[1]">
        <use href="#pv-main" fill="url(#pv-OilGradient)" />
      </g>
      <g :visibility="fState[2]">
        <use href="#pv-main" fill="url(#pv-KeyGradient)" />
      </g>
      <g :visibility="fState[3]">
        <use href="#pv-main" fill="url(#pv-KeyGradient)" />
      </g>
      <g :visibility="fState[4]">
        <use href="#pv-main" fill="url(#pv-KeyGradient)" />
      </g>
      <g :visibility="fState[5]">
        <use href="#pv-main" fill="url(#pv-KeyGradient)" />
      </g>
      <g :visibility="fState[10]">
        <use href="#pv-main" fill="url(#pv-KeyGradient)" />
      </g>
    </svg>
  </div>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "pipeline_vertical",
  mixins: [MixinStates],
};
</script>
